@if (filtersEnabled) {
  <div class="border-b-ui-gray-light border-b flex items-center justify-between">
    <mat-button-toggle-group
      class="desktop-toggle-group"
      (change)="incidentsFilterService.incidentTabStatusFilter = $event.value"
      [value]="incidentsFilterService.incidentTabStatusFilter"
      aria-label="Incident Status"
      name="incident-status"
    >
      <mat-button-toggle
        class="test-incident-status-open"
        [value]="incidentTabStatusFilterEnum.OPEN"
      >
        <span class="item-status-title">Open</span>
      </mat-button-toggle>
      <mat-button-toggle
        class="test-incident-status-history"
        [value]="incidentTabStatusFilterEnum.HISTORY"
      >
        <span class="item-status-title">History</span>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
}

@if (incidentsFilterService.incidentTabStatusFilter === incidentTabStatusFilterEnum.OPEN &&
incidentsFilterService.incidentsData.length &&
filtersEnabled) {
  <div class="test-open-incidents-filters flex items-start justify-between mt-3">
    <div class="flex flex-wrap">
      @if (filtersEnabled && incidentsFilterService.incidentsData.length) {
        <div class="flex justify-center mr-2">
          <app-search-input
            (searchDataEvent)="incidentsFilterService.ticketNumberSearch($event)"
            placeholder="Enter Ticket №"
          />
        </div>
      }
      @if (dropdownFilters) {

        <app-multiple-select
          class="mr-2"
          (selectDataEvent)="incidentsFilterService.multiSelectChange('deviceTypeValue', $event)"
          [options]="incidentsFilterService.deviceTypeOptions"
          [value]="incidentsFilterService.deviceTypeValue"
          label="Device Type"
          panelClass="wide-overlay"
          selectClass="stroked-select-multiple mb-3"
        />

        @if (!incidentsFilterService.isBuildingTable) {
          <mat-form-field
            class="stroked-select-single mr-2 mb-3"
            appearance="outline"
          >
            <mat-select-trigger>Building</mat-select-trigger>
            <mat-select
              [(ngModel)]="incidentsFilterService.selectedBuilding"
              panelClass="single-select-overlay test-building-select-filter"
            >
              @for (building of incidentsFilterService.buildingOptions | sort : 'asc' : 'title' : 'all'; track building.value) {
                <mat-option [value]="building.value">
                  {{ building.title }}
                </mat-option>
              }
            </mat-select>
            <mat-icon
              class="arrow-down"
              matSuffix
            >keyboard_arrow_down
            </mat-icon>
          </mat-form-field>
        }

        @if (incidentsFilterService.selectedBuilding && !incidentsFilterService.isFloorTable) {
          <mat-form-field
            class="stroked-select-single mr-2 mb-3"
            appearance="outline"
          >
            <mat-select-trigger>Floor</mat-select-trigger>
            <mat-select
              [(ngModel)]="incidentsFilterService.selectedFloor"
              panelClass="single-select-overlay test-floor-select-filter"
            >
              @for (floor of incidentsFilterService.floorOptions | sort : 'asc' : 'title' : 'all'; track floor.value) {
                <mat-option [value]="floor.value">
                  {{ floor.title }}
                </mat-option>
              }
            </mat-select>
            <mat-icon
              class="arrow-down"
              matSuffix
            >keyboard_arrow_down
            </mat-icon>
          </mat-form-field>
        }

        @if (incidentsFilterService.selectedFloor && !incidentsFilterService.isRoomTable) {
          <mat-form-field
            class="stroked-select-single mr-2 mb-3"
            appearance="outline"
          >
            <mat-select-trigger>Room</mat-select-trigger>
            <mat-select
              [(ngModel)]="incidentsFilterService.selectedRoom"
              panelClass="single-select-overlay test-room-select-filter"
            >
              @for (room of incidentsFilterService.roomOptions | sort : 'asc' : 'title' : 'all'; track room.value) {
                <mat-option [value]="room.value">
                  {{ room.title }}
                </mat-option>
              }
            </mat-select>
            <mat-icon
              class="arrow-down"
              matSuffix
            >keyboard_arrow_down
            </mat-icon>
          </mat-form-field>
        }

        <app-multiple-select
          class="mr-2"
          (selectDataEvent)="incidentsFilterService.multiSelectChange('severityFilter', $event)"
          [options]="incidentsFilterService.severityOptions"
          [value]="incidentsFilterService.severityFilter"
          label="Severity"
          panelClass="wide-overlay"
          selectClass="stroked-select-multiple mb-3"
        />

        @if (incidentsFilterService.selectedFilters) {
          <button
            class="text-sm text-ui-dark font-normal underline h-9 ml-3 mb-3 test-clear-all-open-incidents-filters"
            (click)="incidentsFilterService.clearOpenIncidentsFilters()"
          >
            Clear All
          </button>
        }
      }
    </div>

    <ng-container *ngTemplateOutlet="columnSelect" />
  </div>
}
@if (incidentsFilterService.incidentTabStatusFilter === incidentTabStatusFilterEnum.HISTORY) {
  <div class="test-resolved-incidents-filters flex items-start justify-between mt-3">
    <div class="flex flex-wrap">
      @if (resolvedIncidentsLoading) {
        <mat-spinner
          class="mr-2"
          color="primary"
          diameter="36"
          matSuffix
        />
      }

      @if (dropdownFilters && incidentsFilterService.resolvedIncidentsData.length) {
        <app-multiple-select
          class="mr-2"
          (selectDataEvent)="incidentsFilterService.multiSelectChange('resolvedIncidentsDeviceTypeValue', $event)"
          [options]="incidentsFilterService.resolvedIncidentsDeviceTypeOptions"
          [value]="incidentsFilterService.resolvedIncidentsDeviceTypeValue"
          label="Device Type"
          panelClass="wide-overlay"
          selectClass="stroked-select-multiple mb-3"
        />

        @if (!incidentsFilterService.isBuildingTable) {
          <mat-form-field
            class="stroked-select-single mr-2 mb-3"
            appearance="outline"
          >
            <mat-select-trigger>Building</mat-select-trigger>
            <mat-select
              [(ngModel)]="incidentsFilterService.resolvedIncidentsSelectedBuilding"
              panelClass="single-select-overlay test-building-select-filter"
            >
              @for (building of incidentsFilterService.resolvedIncidentsBuildingOptions | sort : 'asc' : 'title' : 'all'; track building.value) {
                <mat-option [value]="building.value">
                  {{ building.title }}
                </mat-option>
              }
            </mat-select>
            <mat-icon
              class="arrow-down"
              matSuffix
            >keyboard_arrow_down
            </mat-icon>
          </mat-form-field>
        }

        @if (incidentsFilterService.resolvedIncidentsSelectedBuilding && !incidentsFilterService.isFloorTable) {
          <mat-form-field
            class="stroked-select-single mr-2 mb-3"
            appearance="outline"
          >
            <mat-select-trigger>Floor</mat-select-trigger>
            <mat-select
              [(ngModel)]="incidentsFilterService.resolvedIncidentsSelectedFloor"
              panelClass="single-select-overlay test-floor-select-filter"
            >
              @for (floor of incidentsFilterService.resolvedIncidentsFloorOptions | sort : 'asc' : 'title' : 'all'; track floor.value) {
                <mat-option [value]="floor.value">
                  {{ floor.title }}
                </mat-option>
              }
            </mat-select>
            <mat-icon
              class="arrow-down"
              matSuffix
            >keyboard_arrow_down
            </mat-icon>
          </mat-form-field>
        }

        @if (incidentsFilterService.resolvedIncidentsSelectedFloor && !incidentsFilterService.isRoomTable) {
          <mat-form-field
            class="stroked-select-single mr-2 mb-3"
            appearance="outline"
          >
            <mat-select-trigger>Room</mat-select-trigger>
            <mat-select
              [(ngModel)]="incidentsFilterService.resolvedIncidentsSelectedRoom"
              panelClass="single-select-overlay test-room-select-filter"
            >
              @for (room of incidentsFilterService.resolvedIncidentsRoomOptions | sort : 'asc' : 'title' : 'all'; track room.value) {
                <mat-option [value]="room.value">
                  {{ room.title }}
                </mat-option>
              }
            </mat-select>
            <mat-icon
              class="arrow-down"
              matSuffix
            >keyboard_arrow_down
            </mat-icon>
          </mat-form-field>
        }

        @if (incidentsFilterService.resolvedIncidentsSelectedFilters) {
          <button
            class="text-sm text-ui-dark font-normal underline h-9 ml-3 mb-3 test-clear-all-resolved-incidents-filters"
            (click)="incidentsFilterService.clearResolvedIncidentsFilters()"
            mat-button
          >
            Clear All
          </button>
        }
      }
    </div>
    <ng-container *ngTemplateOutlet="columnSelect"></ng-container>
  </div>
}


<ng-template #columnSelect>
  <div class="flex flex-wrap">
    @if (incidentsFilterService.incidentTabStatusFilter === incidentTabStatusFilterEnum.HISTORY) {
      <avs-date-picker
        class="block w-72 mr-2 mb-3"
        (changed)="incidentsFilterService.resolvedDateRange.patchValue($event); incidentsFilterService.calendarClose()"
        [disabled]="resolvedIncidentsLoading"
        [minDate]="minDate"
      />
    }
    <mat-form-field
      class="column-select mb-3"
      appearance="outline"
      matTooltip="Column Select"
    >
      <mat-select
        (selectionChange)="columnListUpdated($event)"
        [formControl]="incidentsFilterService.columnSelect"
        #columnSelectRef
        multiple
        panelClass="multi-select-overlay column-select-overlay"
      >
        <mat-select-trigger>
          <i class="icon-ic_column text-3xl"></i>
        </mat-select-trigger>
        <div class="options-action-wrapper">
          <button
            class="options-action-button"
            (click)="selectAllColumns()"
          >
            Select All
          </button>
        </div>
        @for (option of incidentsFilterService.columnOptions; track option.value) {
          <mat-option [value]="option.value">
            {{ option.title }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

</ng-template>
